import React from 'react'

import DataTable from '@/components/datatable/DataTable'
import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@/components/ui/table'
import { DATE_FORMATS } from '@/lib/constants'
import { formatDate } from '@/lib/helpers/dateHelpers'
import { PanelInviteItem } from '@/types/responses/panels'
interface Props {
  panelInvite: PanelInviteItem
}

const Overview: React.FC<Props> = ({ panelInvite }) => (
  <section>
    <DataTable tableContainerProps={{ style: { maxWidth: '400px' } }}>
      <TableBody
        css={{
          th: { fontWeight: '500' },
        }}
      >
        {panelInvite.createdAt && (
          <TableRow>
            <TableHead>Invite sent on</TableHead>
            <TableCell>
              {formatDate(panelInvite.createdAt, DATE_FORMATS.DAY_MONTH_YEAR)}
            </TableCell>
          </TableRow>
        )}

        <TableRow>
          <TableHead>Invite sent to</TableHead>
          <TableCell>{panelInvite.email}</TableCell>
        </TableRow>

        {panelInvite.invitedBy && (
          <TableRow>
            <TableHead>Invite created by</TableHead>
            <TableCell>{panelInvite.invitedBy.fullName}</TableCell>
          </TableRow>
        )}

        <TableRow>
          <TableHead>Invite created via</TableHead>
          <TableCell>{panelInvite.readableSource}</TableCell>
        </TableRow>
      </TableBody>
    </DataTable>
  </section>
)

export default Overview
